import { API_KEY } from "./Constants";

export const NewRelese=`/movie/popular?api_key=${API_KEY}`
export const popular=`/movie/top_rated?api_key=${API_KEY}`